(function (window, document) {
  function scrollFraction() {
    try {
      var doc = document.documentElement || {};
      var body = document.body || {};
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var full = Math.max(body.scrollHeight || 0, doc.scrollHeight || 0);
      var viewport = window.innerHeight || doc.clientHeight || 0;
      var scrollable = full - viewport;
      if (scrollable <= 0) return 1;
      return Math.min(1, Math.max(0, scrollTop / scrollable));
    } catch (e) {
      return 0;
    }
  }

  function arm(trigger, applyFn) {
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      try {
        applyFn();
      } catch (e) {
        try {
          console.warn("MVT Engine: activation trigger applyFn error", e);
        } catch (_) {}
      }
    }

    if (!trigger || !trigger.type || trigger.type === "immediate") {
      fire();
      return;
    }

    try {
      if (trigger.type === "time") {
        var ms = Math.max(0, Number(trigger.delaySeconds) || 0) * 1000;
        window.setTimeout(fire, ms);
        return;
      }

      if (trigger.type === "scroll") {
        var threshold = Math.min(1, Math.max(0, (Number(trigger.scrollPercent) || 0) / 100));
        if (scrollFraction() >= threshold) {
          fire();
          return;
        }
        var onScroll = function () {
          if (scrollFraction() >= threshold) {
            window.removeEventListener("scroll", onScroll);
            fire();
          }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return;
      }

      if (trigger.type === "click") {
        var selector = String(trigger.selector || "").trim();
        if (!selector) {
          fire();
          return;
        }
        var onClick = function (e) {
          var node = e.target;
          while (node && node.nodeType === 1) {
            var matched = false;
            try {
              matched = !!(node.matches && node.matches(selector));
            } catch (err) {
              document.removeEventListener("click", onClick, true);
              fire();
              return;
            }
            if (matched) {
              document.removeEventListener("click", onClick, true);
              fire();
              return;
            }
            node = node.parentElement;
          }
        };
        document.addEventListener("click", onClick, true);
        return;
      }

      if (trigger.type === "exit_intent") {
        var onMouseOut = function (e) {
          var to = e.relatedTarget || e.toElement;
          if (!to && (e.clientY == null || e.clientY <= 0)) {
            document.removeEventListener("mouseout", onMouseOut, true);
            fire();
          }
        };
        document.addEventListener("mouseout", onMouseOut, true);
        return;
      }

      fire();
    } catch (e) {
      fire();
    }
  }

  window.MVTTrigger = { arm: arm };
})(window, document);
